import React from 'react';
import c from 'classnames';
import get from 'lodash/get';
import MinimalDumbo from '../MinimalDumbo';
import { getFeature } from '../../../DaEditorWrapper/Features/helper';
import { FIRST_IMAGE_FEATURE } from '../../../DaEditorWrapper/Features';
import s from './Commission.scss';
export function getFirstExample({ commission, textContent }) {
    if (!commission) {
        return;
    }
    if (textContent && textContent.html.type === 'draft') {
        const first = getFeature(FIRST_IMAGE_FEATURE, textContent.html.features);
        return first && first.data && first.data.deviation;
    }
    return commission && commission.examples && commission.examples[0];
}
const Commission = ({ deviation, width, height, className, 'aria-hidden': ariaHidden })=>{
    const example = get(deviation, 'coverImage') || getFirstExample(deviation);
    if (!example) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width,
                height
            },
            className: c(s['default-background'], className)
        });
    }
    return /*#__PURE__*/ React.createElement(MinimalDumbo, {
        className: className,
        deviation: example,
        width: width,
        height: height,
        "aria-hidden": ariaHidden
    });
};
export default Commission;

//# sourceMappingURL=Commission.js.map